import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import TableRow from "@mui/material/TableRow";
import DataTableCell from "./DataTableCell";
import DataTableRowDetails from "./DataTableRowDetails";
/**
 * @deprecated use material-react-table
 * @param param0
 * @returns
 */
function DataTableRow({ row, columns, visibleFields, }) {
    var _a;
    const [openDetails, setOpenDetails] = useState(false);
    const [openLevel, setOpenLevel] = useState(false);
    const subRows = row.rows ? row.rows : [];
    const rowsLength = subRows.length;
    return (_jsxs(_Fragment, { children: [_jsx(TableRow, { onClick: () => (rowsLength > 0 ? setOpenLevel(!openLevel) : undefined), className: "DataTableRow" + (rowsLength > 0 ? " collapsable" : ""), sx: {
                    cursor: rowsLength > 0 ? "pointer" : undefined,
                }, children: columns
                    .filter((column) => !visibleFields ? true : visibleFields.includes(column.field))
                    .map((column) => (_jsx(DataTableCell, { column: column, row: row, openDetails: openDetails, setOpenDetails: setOpenDetails, openLevel: openLevel, setOpenLevel: setOpenLevel }, column.field))) }, row.id), openDetails && row.details && Object.keys(row.details).length > 0 && (_jsx(DataTableRowDetails, { row: row, columnsLength: columns.filter((column) => !visibleFields ? true : visibleFields.includes(column.field)).length })), openLevel &&
                ((_a = row.rows) === null || _a === void 0 ? void 0 : _a.map((row) => (_jsx(DataTableRow, { row: row, columns: columns, visibleFields: visibleFields }, row.id))))] }));
}
export default DataTableRow;
//# sourceMappingURL=DataTableRow.js.map